import { escapeHtml } from "../../ui/text.ts";

export interface TaskReadViewModel {
  customFieldsHtml?: string;
  title: string;
  toolbarHtml: string;
  descriptionHtml: string;
  tags: string[];
  timeContextHtml?: string;
  checklist: boolean;
  completedSubtasks: number;
  subtaskCount: number;
  subtasksHtml: string;
  parentHtml?: string;
  childrenHtml?: string;
  approvalHtml?: string;
  commentsHtml: string;
  hasComments: boolean;
  moreOpen: boolean;
  moreIcon: string;
  presenceHtml: string;
  linkPreviewsHtml: string;
  factsHtml: string;
  dependenciesHtml: string;
  relationshipsHtml: string;
  attachmentsHtml: string;
  activityHtml: string;
}

export function taskReadPanelView(model: TaskReadViewModel): string {
  return `<aside class="detail-panel task-view" aria-label="Task details"><div class="detail-panel__scroll">
    ${model.toolbarHtml}
    <div class="task-view__body">
      <h1 class="task-view-title">${escapeHtml(model.title || "Untitled task")}</h1>
      ${model.parentHtml || ""}
      ${model.descriptionHtml ? `<section class="task-view__section task-description" aria-label="Description"><div class="markdown-body">${model.descriptionHtml}</div></section>` : ""}
      ${model.tags.length ? `<section class="task-view__section" aria-label="Tags"><div class="view-tags">${model.tags.map(tag => `<span class="tag">#${escapeHtml(tag)}</span>`).join("")}</div></section>` : ""}
      ${model.timeContextHtml || ""}
      ${model.customFieldsHtml || ""}
      ${model.childrenHtml || ""}
      ${model.approvalHtml || ""}
      ${model.checklist && model.subtaskCount ? `<section class="task-view__section"><div class="task-view__section-heading"><h3>Subtasks</h3><span>${model.completedSubtasks} of ${model.subtaskCount} completed</span></div><div class="view-subtasks">${model.subtasksHtml}</div></section>` : ""}
      ${model.hasComments ? model.commentsHtml : ""}
      <details class="task-more-details" ${model.moreOpen ? "open" : ""}>
        <summary><span>More details</span>${model.moreIcon}</summary>
        <div class="task-more-details__body">
          <div data-task-presence>${model.presenceHtml}</div>
          ${model.linkPreviewsHtml}
          ${model.factsHtml}
          ${model.dependenciesHtml}
          ${model.relationshipsHtml}
          ${model.attachmentsHtml}
          ${model.hasComments ? "" : model.commentsHtml}
          ${model.activityHtml}
        </div>
      </details>
    </div>
  </div></aside>`;
}
